import React from 'react';
import { TodoEntity } from '../../CU-002-02/models/CardModel';
import { CheckCircleFilled } from '@ant-design/icons';

interface props {
    memberTodo: TodoEntity[];
}

const BLUE_STATUS = [
    'DONE',
    'TO_NEXT_TODO_CLASS'
];

const TODO_CODE_SHOW_MESSAGE = [
    '0001000040',
    '0001000140',
    '0002000070',
    '0002000150'
]

const TODO_MESSAGE = {
    //媒介契約締結
    //MG-043
    '0001000040': (<>
        媒介契約は電子契約となり本アプリ外で締結を実施します。
        <br />
        登録のメールアドレスに契約書のリンクをお送りしますので、ご確認ください。
    </>),
    //代理契約の締結 
    //MG-044
    '0001000140': (<>
        代理契約は電子契約となり本アプリ外で締結を実施します
        <br />
        登録のメールアドレスに契約書のリンクをお送りしますので、ご確認ください。
    </>),
    //不動産売買契約の締結
    //MG-045
    '0002000070': (<>
        不動産売買契約は電子契約となり本アプリ外で締結を実施します
        <br />
        登録のメールアドレスに契約書のリンクをお送りしますので、ご確認ください。
    </>),
    //賃貸管理移管契約の締結
    //MG-046
    '0002000150': (<>
        賃貸管理移管契約は電子契約となり本アプリ外で締結を実施します。
        <br />
        登録のメールアドレスに契約書のリンクをお送りしますので、ご確認ください。
    </>),
}

const TAB2Component = ({ memberTodo }: props) => {
    // let memberTodos = memberTodo.filter((item) => item.todoActiveStatus !== "INACTIVE");
    // memberTodos = memberTodos.reverse()
    // const hasToDoMessage = (item: TodoEntity) => {
    //     return item.todoName
    //         && TODO_CODE_SHOW_MESSAGE.includes(item.todoCode)
    //         && !BLUE_STATUS.includes(item.todoExecStatus);
    // }
    return (
        <>
            {/* <div>
                {memberTodos.length > 0 && <>
                    {memberTodos.filter((item) => item.todoName).map((item, index) => {
                        const todoMessageCode = hasToDoMessage(item) ? item.todoCode : undefined;
                        return (
                            <>
                                <div className='text-left ml-[146px]' key={index}>
                                    <div>
                                        <CheckCircleFilled style={{ fontSize: 14, opacity: BLUE_STATUS.includes(item.todoExecStatus) ? 'unset' : 0.3, width: 20, color: BLUE_STATUS.includes(item.todoExecStatus) ? '#1F8DDD' : 'unset' }} />
                                        {item.todoName}
                                    </div>
                                </div>
                                {todoMessageCode &&
                                    (
                                        <div className='text-left ml-[146px] flex'>
                                            <div className='pr-[7px] pl-[1px]'>
                                                ※
                                            </div>
                                            <div>
                                                {TODO_MESSAGE[todoMessageCode as keyof typeof TODO_MESSAGE]}
                                            </div>
                                        </div>
                                    )}
                            </>

                        )
                    })}
                </>
                ||
                <div style={{ fontWeight: 700, fontSize: 16, paddingTop: 300 }}>現在、TODOはありません</div>} */}
            {/* </div> */}
            <div style={{ fontWeight: 700, fontSize: 16, paddingTop: 300 }}>現在、TODOはありません</div>
        </>
    );
}
export default TAB2Component